import type { ApiClientOptions } from '@/infra/api-client'
import { patchGrpcClient } from '@/utils/grpc-util'
import {
  QuickBooksPlatformConnectionServicePromiseClient,
  XeroPlatformConnectionServicePromiseClient,
} from '@taxfyle/api-internal/internal/bookkeeping_grpc_web_pb'

export class BookkeepingApi {
  readonly quickBooks
  readonly xero

  constructor(options: ApiClientOptions) {
    const baseURL = options.baseURL ?? ''

    this.quickBooks = new QuickBooksPlatformConnectionServicePromiseClient(
      baseURL,
    )
    patchGrpcClient(this.quickBooks, options.token$)

    this.xero = new XeroPlatformConnectionServicePromiseClient(baseURL)
    patchGrpcClient(this.xero, options.token$)
  }
}
